import { Action } from "redux";

const isAction = <T extends string>(
  action: Action,
  type: T,
): action is Extract<Action, { type: T }> => action.type === type;

export const isActionType = <T extends string>(
  action: Action,
  type: T | readonly T[],
): action is Extract<Action, { type: T }> => {
  if (typeof type === "string") {
    return isAction(action, type);
  }

  return type.some((t) => isAction(action, t));
};
